<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Basic
          </div>
          <v-spacer/>
          <div class="ml-4 mr-4 mt-4"
          v-if="this.getDetail !== null && this.getDetail !== undefined">
            <DocumentStatus :data="{
              model: 'STD',
              rev: this.displayDocumentRevTypeA(getDetail.rev),
              sec: getDetail.rev.sec,
              stat: getDetail.rev.stat,
              type: getDetail.rev.type}
              "/>
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 sm12 md8 lg8 xl6>
            <v-text-field
            v-if="enableBasicDataChanges"
            :change="updateFormBasic()"
            v-model="localForm.title"
            :disabled="this.disableEdit"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="title"
            :hint="localForm.title"
            persistent-hint
            ></v-text-field>
            <v-text-field
            v-else
            :label="this.getDetail.basic.title"
            prepend-icon="lock"
            :hint="this.defineDocumentFromTag(this.localForm.tag).title + ' Title'"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 sm12 md8 lg8 xl6>
            <v-text-field
            v-if="enableBasicDataChanges"
            :change="updateFormBasic()"
            v-model="localForm.id"
            :disabled="this.disableEdit"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="sell"
            hint="document tag"
            persistent-hint
            ></v-text-field>
            <v-text-field
            v-else
            :label="this.getDetail.basic.id"
            prepend-icon="sell"
            :hint="this.defineDocumentFromTag(this.localForm.tag).title + ' Tag'"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Data
          </div>
          <v-spacer/>
          <div class="ml-4 mr-4 mt-4">
            {{displayDocumentIDGTypeA(this.getDetailBasic.tag, this.getDetailBasic.idg)}}
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :label="displayDocumentID(this.getDetailBasic.did)"
            prepend-icon="fingerprint"
            hint="document id"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :label="displayDocumentID(this.getDetailBasic.idg)"
            prepend-icon="pin"
            hint="generated id"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12>
            <v-text-field
            :change="updateFormBasic()"
            v-model="localForm.hash"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="tag"
            hint="search tags"
            :disabled="this.getDetailChar.stat === true"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2"
        v-if="this.getDetail.basic.tag === 'C1'">
          <v-flex xs12 md8 lg6>
            <v-text-field
            v-model="this.getDetail.char.abn"
            prepend-icon="pin"
            hint="abn"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            v-model="this.getDetail.char.acn"
            prepend-icon="confirmation_number"
            hint="acn"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-spacer/>
          <!-- <ArchiveNew :data="{btnTitle: 'Doc Archive', btnSize: 'icon'}"/> -->
          <AssetNew
          :data="{btn: 'icon', copy: true, detail: this.getDetail}"
          v-if="this.getDetailBasic.tag === 'A1'"/>
          <GetSpecificPage
          v-if="
          this.getDetailBasic.tag === 'W1' ||
          this.getDetailBasic.tag === 'W2'
          "
          :data="{
            tag: this.getDetailBasic.tag,
            page: '/worktooldetail',
            size: 'icon',
            item: this.getDetail}"
          />
          <MaintCallNew :data="{btnTitle: 'New Call', btnSize: 'icon'}"
          v-if="this.getDetailBasic.tag === 'M5'"/>
          <StatsReadCard :data="{tag: this.getDetail.basic.tag}" v-if="this.getDetailBasic.tag !== 'A1'"/>
          <StatsReadCardOpen :data="{tag: this.getDetail.basic.tag}"/>
          <RevisionReadCard v-if="this.getDetailBasic.tag !== 'G1'"/>
          <GetDocumentLogListPage :data="{size: 'icon'}"/>
          <SaveControl/>
          <ActiveControl/>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument.js";
import revFunctions from "@/data/functions/mixins/revFunctions.js";
import SaveControl from "@/data/save/components/SaveControl";
import ActiveControl from "@/data/active/components/ActiveControl";
import DocumentStatus from "@/document/revisions/components/DocumentStatus";
import GetDocumentLogListPage from "@/document/log/components/GetDocumentLogListPage";
import RevisionReadCard from "@/document/revisions/components/RevisionReadCard";
import StatsReadCard from "@/support/stats/components/StatsReadCard";
import StatsReadCardOpen from "@/support/stats/components/StatsReadCardOpen";
// import ArchiveNew from "@/document/archive/components/ArchiveNew";
import GetSpecificPage from "@/support/detail/components/GetSpecificPage";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import docLogFunctions from "@/document/log/mixins/docLogFunctions.js";
import documentFunctions from "@/data/functions/mixins/documentFunctions.js";
import AssetNew from "@/asset/asset/components/AssetNew";
import MaintCallNew from "@/maintenance/call/components/MaintCallNew";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      did: null,
      tag: null,
      localForm: {
        title: "",
        id: "",
        hash: "",
        tag: "C1"
      },
      orgForm: {
        title: "",
        id: "",
        hash: "",
        tag: "C1"
      }
    };
  },
  beforeDestroy() {
    // console.log("HERE");
    // console.log(this.did);
    // ENABLE Save for Others
    let did = this.did;
    let db = this.defineDataSourceFromTag(this.tag);
    this.setDetailBasicSave(db, did, true); // reset save (available for others)
    this.setDetailBasicList(db, did, false); // reset list
  },
  beforeMount() {
    // Prepare for doc log
    this.prepareForDocumentLog();
    // Reload STATS (to cater for race conditions)
    // fix orginal data before change
    this.localForm.title = this.getDetail.basic.title;
    this.localForm.id = this.getDetail.basic.id;
    this.localForm.hash = this.getDetail.basic.hash;
    this.localForm.tag = this.getDetail.basic.tag;

    this.orgForm.title = this.getDetail.basic.title;
    this.orgForm.id = this.getDetail.basic.id;
    this.orgForm.hash = this.getDetail.basic.hash;
    this.orgForm.tag = this.getDetail.basic.tag;

    this.tag = this.getDetail.basic.tag;
    this.did = this.getDetail.basic.did;
    // SPECIAL OPS for ACTION
    if (this.getDetailBasic.tag === "B3") {
      // First element of array is assignee.
      let assignee = this.getRolesList[0].user.udid;
      this.$store.dispatch("changeRoleAssigneeDIDCurrent", assignee);
      this.$store.dispatch("changeRoleAssigneeDIDPrevious", assignee);
    }

    // // BUDGET DID
    // if (this.getDetailBasic.tag === "B4") {
    //   // this.$store.dispatch("changeBudgetDID", "this.getDetailBasic.did");
    // }
    // // BUDGET DID
    // if (this.getDetailBasic.tag === "B6") {
    //   this.$store.dispatch("changePlanDID", this.getDetailBasic.did);
    // }
    // // MATERIAL DID
    // if (this.getDetailBasic.tag === "L1") {
    //   this.$store.dispatch("changeMaterialDID", this.getDetailBasic.did);
    // }
    // LINK DID
    if (this.getDetailLink !== null && this.getDetailLink !== undefined) {
      // console.log("START BUDGET");
      if (this.getDetailLink.bdid !== "" && this.getDetailBasic.tag !== "B4") {
        this.$store.dispatch("changeBudgetDID", this.getDetailLink.bdid);
      }
    }
  },
  // mounted() {
  //   this.$store.dispatch("changeDetailStats", this.getStatsRemote);
  // },
  mixins: [
    describeDocument,
    displayFunctions,
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    numberFunctions,
    revFunctions,
    docLogFunctions,
    documentFunctions
  ],
  components: {
    AssetNew,
    // ArchiveNew,
    ActiveControl,
    SaveControl,
    DocumentStatus,
    GetDocumentLogListPage,
    GetSpecificPage,
    StatsReadCard,
    StatsReadCardOpen,
    RevisionReadCard,
    MaintCallNew
  },
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailBasic",
      "getDetailChar",
      "getDetailLink",
      "getRolesList",
      "getPreviousPage"
    ]),
    disableEdit() {
      let logic = null;
      if (this.getDetailBasic.tag === "E8") {
        if (
          this.getDetailChar.stat === true ||
          this.getPreviousPage === "/reportlist" ||
          this.getPreviousPage === "/reportdetaillist"
        ) {
          logic = true;
        } else {
          logic = false;
        }
      } else {
        logic = false;
      }
      return logic;
    },
    enableBasicDataChanges() {
      let logic = null;
      let tag = null;
      if (this.getDetail !== null) {
        tag = this.getDetail.basic.tag;
      }
      if (
        tag === "C1" ||
        tag === "F1" ||
        tag === "B3" ||
        tag === "M5" ||
        tag === "M7" ||
        tag === "W2"
      ) {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    }
  },
  methods: {
    updateFormBasic() {
      let basic = this.getDetailBasic;
      if (
        this.localForm.title !== this.orgForm.title &&
        this.localForm.title !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.title = this.localForm.title;
        // basic
        basic.title = this.localForm.title;
        this.$store.dispatch("changeDetailBasic", basic);
        this.saveDocumentRevMod(1.51, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (this.localForm.id !== this.orgForm.id && this.localForm.id !== "") {
        // after the change re-assign new Local to Org
        this.orgForm.id = this.localForm.id;
        // basic
        basic.id = this.localForm.id;
        this.$store.dispatch("changeDetailBasic", basic);
        this.saveDocumentRevMod(1.52, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.hash !== this.orgForm.hash &&
        this.localForm.hash !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.hash = this.localForm.hash;
        // basic
        basic.hash = this.localForm.hash;
        this.$store.dispatch("changeDetailBasic", basic);
        this.saveDocumentRevMod(2.81, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
